import React, { useContext } from 'react';
import { Bar } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext'; // Ensure this path is correct
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const AduanaRevenueChart = () => {
  const { netRevenue, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!netRevenue) {
    return <div>No net revenue data available</div>;
  }

  // Filter and aggregate data by Aduana
  const grossData = netRevenue.filter(item => item.Agrupacion === "GROSS");
  const aduanaTotals = grossData.reduce((acc, item) => {
    const aduana = item.Aduana;
    const haberAmount = parseFloat(item.Haber);

    if (!acc[aduana]) {
      acc[aduana] = 0;
    }

    acc[aduana] += haberAmount;
    return acc;
  }, {});

  // Prepare chart data
  const chartData = {
    labels: Object.keys(aduanaTotals),
    datasets: [
      {
        label: 'Total Haber by Aduana',
        data: Object.values(aduanaTotals),
        backgroundColor: '#4B77BE',
        hoverBackgroundColor: '#354A5F',
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800">Aduana Revenue</h2>
      </div>
      <div className="h-64">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default AduanaRevenueChart;
